import React from "react";
import { useTranslation } from "react-i18next";

export default function DevelopmentNoticeModal({ onClose }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4 text-primary">
      <div className="bg-white rounded-2xl p-6 max-w-3xl w-full shadow-lg text-center">
        <h2 className="text-xl font-bold mb-2">
          {t("developmentNotice.title")}
        </h2>
        <p className="mb-4 text-sm">{t("developmentNotice.description")}</p>
        <p className="mb-4 text-sm font-medium">
          {t("developmentNotice.features")}
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-2">
          <button
            onClick={onClose}
            className="bg-primary text-white px-4 py-2 rounded-full hover:bg-primary-dark transition"
          >
            {t("developmentNotice.button.explore")}
          </button>
        </div>
      </div>
    </div>
  );
}
